import { InfiniteData, QueryClient } from "react-query";
import { IPaginated } from "@edgetier/types";
import { IPhraseTriggerResult, Route } from "@edgetier/watchtower-types";

export const removeFromCache = (queryClient: QueryClient, phraseTriggerResultId: string) => {
    queryClient.setQueriesData<InfiniteData<IPaginated<IPhraseTriggerResult>> | undefined>(
        [Route.PhraseTriggersResults],
        (phraseTriggerResults) => {
            if (typeof phraseTriggerResults === "undefined") {
                return undefined;
            }

            return {
                ...phraseTriggerResults,
                pages: phraseTriggerResults.pages.map((page) => {
                    return {
                        ...page,
                        items: page.items.filter(
                            (phraseTriggerResult) => phraseTriggerResult.phraseTriggerResultId !== phraseTriggerResultId
                        ),
                    };
                }),
            };
        }
    );
};
